module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation7.7439b988.png";